import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import { TiChartLine } from "react-icons/ti";

import ResponsiveDrawer from "../components/ResponsiveDrawer";
import ProgressBar from "../components/ProgressBar";

import {
  MdSwapHorizontalCircle,
  MdOutlineSimCardDownload,
  MdOutlineRefresh,
  MdAccountBalanceWallet,
  MdError,
} from "react-icons/md";
import { makeStyles } from "@material-ui/core";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles((theme) => {
  return {
    display: {
      display: "flex",
      // justifyContent: "space-between",
    },

    root: {
      minHeight: "100vh",
      backgroundColor: "#F7F8FA",
    },
    toolbar: {
      height: "64px",
    },
    refresh: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      maxWidth: 558,
    },
    info: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
      borderRadius: "12px",
      boxShadow: "0px 2px 6px #0000000a",
      height: "200px",
      borderRight: "10px !important",
    },
    infoDonwload: {
      padding: "1rem",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column",
      flex: 1,
      borderRadius: "12px",
      boxShadow: "0px 2px 6px #0000000a",
      height: "200px",
    },

    boxNoTransac: {
      backgroundColor: "#ffff",
      borderRadius: "12px",
      padding: "12px",
      display: "flex",
      justifyContent: "center",
      height: "250px",
    },
    boxTransac: {
      padding: "15px",
      // height: "370px",
      boxShadow: "0px 2px 6px #0000000a",
      borderRadius: "12px",
      backgroundColor: "#fff",
    },
    boxBanner: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "12px",
      height: "250px",
      [theme.breakpoints.up("md")]: {
        height: "420px",
      },
      boxShadow: "0px 2px 6px #0000000a",
    },
    icon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "51px",
      height: "51px",
    },
  };
});

function Home(props) {
  const classes = useStyles();

  // Creation du state qui est un tableau vide afin de recharger au chargement de la page les dernières transactions
  const [latestTransactions, setLatestTransactions] = useState([]);
  const [isLatestTransactions, setIsLatestTransactions] = useState(true);
  const [chiffreAffaire, setChiffreAffaire] = useState(0);
  const [transactionJournaliere, setTransactionJournaliere] = useState(0);
  const [totalCashback, setTotalCashback] = useState(0);
  const [merchants, setMerchants] = useState(0);
  const [loading, setLoading] = useState(true);
  const [openFailed, setOpenFailed] = useState(false);

  let tokenStorage = null;

  // useEffect d'inititialisation, chargement des informations
  useEffect(() => {
    if (props.token) {
      tokenStorage = props.token;
    }

    // const interval = setInterval(() => {
    // console.log("this will run every second");
    requestDataHome();
    // }, 2000);
    // return () => clearInterval(interval);
  }, []);

  const requestDataHome = async () => {
    try {
      const dataHome = await fetch(
        "https://bck-bdx.carloapp.com/api/business/home_page",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Version: "4.0",
            Authorization: `Bearer ${tokenStorage}`,
          },
        }
      );
      const body = await dataHome.json();
      setLatestTransactions(body.data.latest_transactions);
      setTotalCashback(body.data.total_cashback);
      setChiffreAffaire(body.data.revenue);
      setTransactionJournaliere(body.data.transactions_count);
      setMerchants(body.data.merchants);
      setLoading(false);

      if (body.data.latest_transactions.length === 0) {
        setIsLatestTransactions(false);
      } else {
        setIsLatestTransactions(true);
      }
    } catch (error) {
      console.error("Error fetching home data:", error);
      setLoading(false);
      // Set default values to prevent crashes
      setLatestTransactions([]);
      setIsLatestTransactions(false);
      setChiffreAffaire(0);
      setTransactionJournaliere(0);
      setTotalCashback(0);
      setMerchants(0);
    }
  };

  const handleRefresh = () => {
    setLoading(true);
    requestDataHome();
  };

  // req daily report
  // const reqDailyReport = async () => {
  //   setLoading(true);
  //   const date = new Date();
  //   let day = date.getDate();
  //   let month = date.getMonth() + 1;
  //   let year = date.getYear() + 1900;
  //   await axios
  //     .get(
  //       `https://bck-bdx.carloapp.com/api/business/my_daily_report?date=${year}/${month}/${day}`,
  //       {
  //         method: "GET",
  //         responseType: "blob",
  //         headers: {
  //           Version: "4.0",
  //           Authorization: `Bearer ${tokenStorage}`,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       const blog = res.data;
  //       if (blog.type === "application/json") {
  //         setOpenFailed(true);
  //         setLoading(false);
  //       } else {
  //         setLoading(false);
  //         const url = window.URL.createObjectURL(new Blob([res.data]));
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.setAttribute("download", `${day}-${month}-${year}.xls`);
  //         document.body.appendChild(link);
  //         link.click();
  //         link.remove();
  //       }
  //     });
  // };

  const listTransactions = latestTransactions.map((transaction, i) => {
    return (
      <Box
        key={i}
        mb={1}
        className={classes.boxTransac}
        sx={{ display: "flex", flexDirection: "row" }}
      >
        {<Avatar src={transaction.profile_picture_url} /> ? (
          <Avatar src={transaction.profile_picture_url} />
        ) : (
          <Avatar />
        )}
        <Box ml={3}>
          <Typography sx={{ fontWeight: "bold" }}>
            {transaction.customer_name}
          </Typography>
          <Typography>{transaction.amount}€</Typography>
          <Typography variant="body2" sx={{ color: "#6b7280" }}>
            {transaction.payment_note || "-"}
          </Typography>
        </Box>
      </Box>
    );
  });

  // Redirect user if not logged in
  let isLoggedIn = localStorage.getItem("token");
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    // passing the token in the redux store
    props.onSetToken(tokenStorage);
  }

  return (
    // Mini drawer + Nav
    <Box sx={{ display: "flex" }}>
      {/* <MiniDrawer /> */}
      <ResponsiveDrawer />
      <Box
        className={classes.root}
        sx={{ flexGrow: 1, p: 3, bgColor: "#F7F8FA" }}
      >
        <div className={classes.toolbar}></div>

        {/* Start of component */}
        {/* ternary condition to show loading while waiting for api response */}
        {loading ? (
          <ProgressBar />
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <Box mb={3} mt={3} className={classes.refresh}>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: "#202731",
                  }}
                >
                  Aperçu de statistiques{" "}
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<MdOutlineRefresh />}
                  onClick={() => handleRefresh()}
                >
                  Rafraîchir les données
                </Button>
              </Box>
            </Grid>

            {/* Grid that contains the stats */}
            <Grid container spacing={2} className={classes.display}>
              <Grid item xs={12} sm={6} lg={3}>
                <Box className={classes.info} sx={{ backgroundColor: "#FFF" }}>
                  <Link to="#" className="icons">
                    <TiChartLine />
                  </Link>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      color: "#000",
                    }}
                  >
                    {chiffreAffaire.toLocaleString("fr")} €
                  </Typography>
                  <Typography
                    variant="h7"
                    sx={{
                      fontWeight: "semi-bold",
                      color: "#000",
                    }}
                  >
                    Chiffre d'affaire journalier
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} lg={3}>
                <Box className={classes.info} sx={{ backgroundColor: "#FFF" }}>
                  <Link to="#" className="icons">
                    <MdSwapHorizontalCircle />
                  </Link>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: "bold", color: "#000000" }}
                  >
                    {transactionJournaliere.toLocaleString("fr")}
                  </Typography>
                  <Typography
                    variant="h7"
                    sx={{ fontWeight: "semi-bold", color: "#000000" }}
                  >
                    Transactions
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} lg={3}>
                <Box className={classes.info} sx={{ backgroundColor: "#FFF" }}>
                  <Link to="#" className="icons">
                    <MdAccountBalanceWallet />
                  </Link>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#000000" }}
                  >
                    {totalCashback} €
                  </Typography>
                  <Typography
                    variant="h7"
                    sx={{
                      fontWeight: "semi-bold",
                      color: "#000",
                    }}
                  >
                    Portefeuille utilisateurs
                  </Typography>
                </Box>
              </Grid>

              {/* <Grid item xs={12} sm={6} lg={3}> */}
              {/* <Box
                  className={classes.infoDonwload}
                  sx={{ backgroundColor: "#FFF" }}
                >
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Rapport journalier :{" "}
                  </Typography>
                  <Button
                    variant="outlined"
                    endIcon={<MdOutlineSimCardDownload />}
                    onClick={() => reqDailyReport()}
                    style={{
                      textTransform: "none",
                      // backgroundColor: "#98CBF3",
                    }}
                  >
                    Téléchargez votre rapport comptable de la journée
                  </Button>
                </Box> */}
              {/* </Grid> */}
            </Grid>

            <Grid item xs={12}>
              <Box
                mb={3}
                mt={3}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: "#202731",
                  }}
                >
                  Dernières transactions complétées
                </Typography>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  {isLatestTransactions ? (
                    <Box>{listTransactions}</Box>
                  ) : (
                    <Box className={classes.boxNoTransac}>
                      <Box
                        component="img"
                        alt="Component"
                        src="/no_pending_requests.svg"
                        width="50%"
                      />
                    </Box>
                  )}
                </Grid>
                {/* 
                <Grid item xs={12} md={6}>
                  <Box className={classes.boxBanner}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: 2,
                      }}
                    >
                      <Typography mb={3} style={{ fontWeight: "bold" }}>
                        Nous avons besoin de vous!
                      </Typography>
                      <Typography mb={2}>
                        Ameliorer Carlo en répondant à ce sondage
                      </Typography>
                      <Button
                        variant="contained"
                        onClick={() => {
                          const url =
                            "https://forms.office.com/Pages/ResponsePage.aspx?id=5tX1PNRX-E2xrXFD4yNcWO2supRsWRRDkEorU3p6kThUMUs0N0taNVpDUDJOOElVOE03SU1VTDdCRC4u";
                          window.open(url, "_blank");
                        }}
                      >
                        Répondre
                      </Button>
                    </Box>
                    <Box
                      component="img"
                      src="banner-survey.png"
                      height="230px"
                      width="280px"
                    />
                  </Box>
                </Grid>
                 */}
              </Grid>
            </Grid>
          </Grid>
        )}

        {/* Modal to show no daily report exists */}

        <Modal open={openFailed}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "#fff",
              p: 4,
              borderRadius: 5,
            }}
          >
            <IconButton color="error" className={classes.icon}>
              <MdError className={classes.icon} />
            </IconButton>
            <Typography mb={2}>
              Vous n'avez pas effectué de transaction ou reçu de gain parrainage
              ce jour.
            </Typography>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenFailed(false)}
            >
              Fermer
            </Button>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
